export class ScraperPicture extends HTMLElement {
  #url
  #selected
  #containerSelectedClass

  connectedCallback() {
    this.#selected = false
    this.#containerSelectedClass = this.getAttribute('container-selected-class')

    this.#setContainer()
    this.#setImage()
  }

  disconnectedCallback() {
    this.#selected = false
    this.#url = null
    this.#containerSelectedClass = null

    this.container = undefined
    this.image = undefined
  }

  get url() {
    return this.#url
  }

  set url(value) {
    this.#url = value
    this.image.src = value
  }

  get selected() {
    return this.#selected
  }

  set selected(value) {
    this.#selected = value
    if (this.#selected) this.container.classList.add(this.#containerSelectedClass)
    else this.container.classList.remove(this.#containerSelectedClass)
  }

  // The markers stay in place: a Turbo snapshot (back navigation, cache
  // preview) clones the element, which must find them again when it reconnects.
  #setContainer() {
    this.container = this.querySelector('[sp-container]')
  }

  #setImage() {
    this.image = this.querySelector('[sp-image]')
  }
}
